/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupcancelconfirm2Inputs */

const en_signupcancelconfirm2 = /** @type {(inputs: Signupcancelconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Really cancel?`)
};

const de_signupcancelconfirm2 = /** @type {(inputs: Signupcancelconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirklich abmelden?`)
};

/**
* | output |
* | --- |
* | "Really cancel?" |
*
* @param {Signupcancelconfirm2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupcancelconfirm2 = /** @type {((inputs?: Signupcancelconfirm2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupcancelconfirm2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupcancelconfirm2(inputs)
	return de_signupcancelconfirm2(inputs)
});
export { signupcancelconfirm2 as "signupCancelConfirm" }